import { defineStore } from 'pinia';
import customerApi from '../api/customerApi';

export const useCustomerStore = defineStore('customerStore', {
    state: () => ({
        customers: [],
        customer: null,
    }),

    actions: {
        async loadCustomers({ page = 1, page_size, search = '', is_active, ordering, responsible } = {}) {
            try {
                const params = { page };
                if (page_size) params.page_size = page_size;
                if (search) params.q = search;
                if (typeof is_active === 'boolean') params.is_active = is_active;
                if (ordering) params.ordering = ordering;
                if (responsible !== undefined && responsible !== null && responsible !== '') {
                    params.responsible = responsible;
                }

                const response = await customerApi.getCustomers(params);
                this.customers = Array.isArray(response?.results) ? response.results : [];
                return response; // { count, results }
            } catch (error) {
                console.error('Ошибка загрузки клиентов:', error);
                throw error;
            }
        },

        async loadCustomer(id) {
            try {
                this.customer = await customerApi.getCustomer(id);
            } catch (error) {
                console.error('Ошибка загрузки клиента:', error);
            }
        },

        async addCustomer(data) {
            try {
                await customerApi.createCustomer(data);
            } catch (error) {
                console.error('Ошибка добавления клиента:', error);
                throw error;
            }
        },

        async updateCustomer(id, data, method = 'put') {
            try {
                await customerApi.updateCustomer(id, data, method);
                await this.loadCustomer(id);
            } catch (error) {
                console.error('Ошибка обновления клиента:', error);
                throw error;
            }
        },

        async archiveCustomer(id) {
            try {
                await customerApi.archiveCustomer(id);
                this.customer = null;
            } catch (error) {
                console.error('Ошибка архивирования клиента:', error);
                throw error;
            }
        },
        async unarchiveCustomer(id) {
            try {
                await customerApi.unarchiveCustomer(id);
                await this.loadCustomer(id);
            } catch (error) {
                console.error('Ошибка разархивирования клиента:', error);
                throw error;
            }
        },
        async deleteCustomer(id) {
            try {
                await customerApi.deleteCustomer(id);
                this.customer = null;
            } catch (error) {
                console.error('Ошибка удаления клиента:', error);
                throw error;
            }
        }
    },
});
